import {
  useCart,
  useCartAddDiscount,
  useCartRemoveDiscount,
} from '@backpackjs/storefront';
import { useEffect, useState } from 'react';
import { Svg } from '../Svg';

export function CartDiscount() {
  const [discountCode, setDiscountCode] = useState('');
  const [applied, setApplied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(false);

  const { cartAddDiscount, ...addDiscountStatus } = useCartAddDiscount();
  const { cartRemoveDiscount, ...removeDiscountStatus } =
    useCartRemoveDiscount();

  const handleRemoveDiscount = async () => {
    await cartRemoveDiscount();
    setApplied(false);
    setDiscountCode('');
  };

  const handleApplyDiscount = async () => {
    setError(false);
    const cartAddDiscountRS = await cartAddDiscount({
      discountCode,
    });

    if (
      cartAddDiscountRS?.discountCodes?.length &&
      cartAddDiscountRS?.discountCodes[0]?.code === discountCode &&
      cartAddDiscountRS?.discountCodes[0]?.applicable === true
    ) {
      setApplied(true);
    } else {
      setError(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (applied) {
      await handleRemoveDiscount();
    } else {
      await handleApplyDiscount();
    }
  };

  const cart = useCart();

  useEffect(() => {
    if (
      cart?.discountCodes.length &&
      cart?.discountCodes[0].applicable === true
    ) {
      setApplied(true);
      setDiscountCode(cart?.discountCodes[0].code);

      if (discountCode === cart?.discountCodes[0].code) {
        setDiscountCode(cart?.discountCodes[0].code);
      }
    }
  }, [cart, discountCode]);

  useEffect(() => {
    if (!cart) {
      return;
    }
    if (!cart.discountCodes.length) {
      setApplied(false);
      setDiscountCode('');
    }
  }, [cart?.discountCodes]);

  return (
    <div className="discount-code-wrapper bg-[#ecf7ff] px-[18px] py-3">
      <button
        aria-label={`${isOpen ? 'Close' : 'Open'} accordion for discount code}`}
        className="flex w-full items-center justify-between gap-x-4 text-left"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <p className="text-xs font-normal tracking-[-0.01em]">Discount Code</p>
        {isOpen ? (
          <Svg
            className="w-4 text-current"
            src="/svgs/minus.svg#minus"
            title="Minus"
            viewBox="0 0 24 24"
          />
        ) : (
          <Svg
            className="w-4 text-current"
            src="/svgs/plus.svg#plus"
            title="Plus"
            viewBox="0 0 24 24"
          />
        )}
      </button>

      <div className={`pb-2 pt-4 ${isOpen ? 'block' : 'hidden'}`}>
        <form className="input-group relative" onSubmit={handleSubmit}>
          <input
            aria-label="Discount Code"
            id="discount-code-input"
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? 'discount-code-error' : undefined}
            className={`h-[40px] w-full min-w-0 flex-1 border border-[#E9E9EB] px-4 py-2 text-xs font-light outline-none placeholder:text-[#343B49] ${
              applied ? 'text-mediumGray' : ''
            }`}
            placeholder="Discount Code"
            onChange={({ target }) => setDiscountCode(target.value)}
            value={discountCode}
            readOnly={applied}
          />
          {applied ? (
            <div className="absolute right-[3px] top-0 flex h-[40px] items-center px-[18px] text-xs uppercase text-[var(--success)]">
              <span>Applied</span>
              <Svg
                className="ml-2 w-[14px] text-[var(--success)]"
                src="/svgs/checkmark-with-circle-filled.svg#checkmark-with-circle-filled"
                title="Discount Code Applied"
                viewBox="0 0 14 14"
              />
            </div>
          ) : (
            <button
              type="submit"
              disabled={!discountCode.length || addDiscountStatus?.loading}
              className={`absolute right-[3px] top-0 flex h-full cursor-pointer items-center px-[18px] text-xs uppercase ${
                applied ? 'text-[var(--success)]' : 'text-[var(--secondary)]'
              }`}
            >
              <span>Apply</span>
            </button>
          )}
        </form>

        {error && (
          <div
            id="discount-code-error"
            className="pt-3 text-xs text-error"
            aria-live="polite"
            role="alert"
          >
            Invalid or expired discount code
          </div>
        )}
      </div>
    </div>
  );
}
